export type IsoMoney = 'USD' | 'CRC';

/** CRC por 1 USD (ej. 520). */
export function convertToBaseCurrency(
  amount: number,
  txCurrency: IsoMoney,
  baseCurrency: IsoMoney,
  crcPerOneUsd: number,
): number {
  if (txCurrency === baseCurrency) return roundMoney(amount);
  if (crcPerOneUsd <= 0 || !Number.isFinite(crcPerOneUsd)) return roundMoney(amount);

  if (baseCurrency === 'CRC' && txCurrency === 'USD') {
    return roundMoney(amount * crcPerOneUsd);
  }
  if (baseCurrency === 'USD' && txCurrency === 'CRC') {
    return roundMoney(amount / crcPerOneUsd);
  }
  return roundMoney(amount);
}

export function roundMoney(n: number): number {
  return Math.round(n * 100) / 100;
}
